import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import PropTypes from "prop-types";
import { AppColors } from "../util/AppColors";

const checkBoxStyle = {
  "&.MuiCheckbox-root": { width: 20, height: 20, margin: 1 },
  "&.Mui-checked": {
    // background: "linear-gradient(to right, red, orange)",
    borderRadius: "50%",
    width: 20,
    height: 20,
    margin: 1,
    color: AppColors.appPrimary,
  },
};

const checkStyle = {
  "&.MuiCheckbox-root": {
    width: 20,
    height: 20,
    margin: 1,
    background: AppColors.white,
    borderRadius: 0,
  },
  "&.Mui-checked": {
    borderRadius: 0,
    width: 20,
    height: 20,
    margin: 1,
    color: AppColors.appPrimary,
  },
};

const CustomCheckbox = ({
  label,
  name,
  onChange,
  checked,
  disabled,
  circle,
  radio,
  radios,
  defaultValue,
  isRow,
}) => {
  if (radio) {
    return (
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={defaultValue}
        name={name}
        onChange={onChange}
        row={isRow}
      >
        {radios?.length > 0 &&
          radios?.map((radio, i) => (
            <FormControlLabel
              key={i}
              value={radio?.value}
              defaultValue={radio?.value}
              control={<Radio />}
              label={radio?.label}
              disabled={disabled}
              sx={{ fontFamily: "Montserrat" }}
            />
          ))}
      </RadioGroup>
    );
  }

  if (circle) {
    return (
      <FormControlLabel
        control={
          <Checkbox
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<CheckCircleIcon />}
            checked={checked}
            onChange={() => onChange(checked)}
            name={name}
            disabled={disabled}
            sx={checkBoxStyle}
          />
        }
        label={label}
      />
    );
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={() => onChange(checked)}
          name={name}
          disabled={disabled}
          sx={checkStyle}
        />
      }
      label={label}
    />
  );
};

CustomCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  circle: PropTypes.bool,
  radio: PropTypes.bool,
  radios: PropTypes.array,
  defaultValue: PropTypes.string,
  isRow: PropTypes.bool,
};

CustomCheckbox.defaultProps = {
  label: "",
  name: "",
  onChange: () => {},
  checked: false,
  disabled: false,
  circle: false,
  radio: false,
  radios: [],
  defaultValue: "",
  isRow: true,
};

export default CustomCheckbox;
